module.exports = __webpack_public_path__ + "static/media/bestT.fd01bf82.png";